import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { LOCIZE_NAMESPACE } from '../../../common'
import { i18nKeyPrefix } from '../i18n'

import { Container, Error, ItemContainer, ItemsContainer, Label } from './Days.styles'
import { IDays } from './types'

const PRE = `${i18nKeyPrefix}-DESIRED-WEEKLY-SCHEDULE-DAYS`

interface IProps {
  days: IDays
  validationHint?: string
  onChangeDays: (days: Partial<IDays>) => void
}

export default function Days(props: IProps) {
  const { days, validationHint, onChangeDays } = props
  const { monday, tuesday, wednesday, thursday, friday } = days
  const { t } = useTranslation(LOCIZE_NAMESPACE)

  return (
    <Container>
      <ItemsContainer>
        <ItemContainer selected={monday} onClick={() => onChangeDays({ monday: !monday })}>
          <Label selected={monday}>{t(`${PRE}-MON`)}</Label>
        </ItemContainer>
        <ItemContainer selected={tuesday} onClick={() => onChangeDays({ tuesday: !tuesday })}>
          <Label selected={tuesday}>{t(`${PRE}-TUE`)}</Label>
        </ItemContainer>
        <ItemContainer selected={wednesday} onClick={() => onChangeDays({ wednesday: !wednesday })}>
          <Label selected={wednesday}>{t(`${PRE}-WED`)}</Label>
        </ItemContainer>
        <ItemContainer selected={thursday} onClick={() => onChangeDays({ thursday: !thursday })}>
          <Label selected={thursday}>{t(`${PRE}-THU`)}</Label>
        </ItemContainer>
        <ItemContainer selected={friday} onClick={() => onChangeDays({ friday: !friday })}>
          <Label selected={friday}>{t(`${PRE}-FRI`)}</Label>
        </ItemContainer>
      </ItemsContainer>

      {validationHint && <Error>{validationHint}</Error>}
    </Container>
  )
}
